import { atom } from "jotai";

import type { Option, SetCodeEnum } from "@sorcery/db";

import type { CardSortEnum } from "~/types/card";
import type { CollectionCardDTOType, CollectionDTOType } from "~/types/collection";
import type { SEARCH_SORT } from "~/utils/filters";

export type SearchType = {
  query: string;
  set: SetCodeEnum | "*";
  filters: Option[];
  sort?: CardSortEnum | typeof SEARCH_SORT;
};

// base
export const collectionJotai = atom<CollectionDTOType | null>();
export const fullCollectionlistJotai = atom<CollectionCardDTOType[]>();
export const filteredCollectionlistJotai = atom<CollectionCardDTOType[]>();
export const collectionQuickEditJotai = atom(false);

// derived
export const collectionlistJotai = atom<CollectionCardDTOType[] | undefined>(
  (get) => get(filteredCollectionlistJotai) ?? get(fullCollectionlistJotai),
);

// resetter
export const collectionResetterJotai = atom(null, (_, set) => {
  set(collectionJotai, undefined);
  set(fullCollectionlistJotai, undefined);
  set(filteredCollectionlistJotai, undefined);
  set(collectionQuickEditJotai, false);
});
